
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type GetTweetById200MediaLinksItemLinkType = typeof GetTweetById200MediaLinksItemLinkType[keyof typeof GetTweetById200MediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetById200MediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
